module.exports = __webpack_public_path__ + "img/flux-kontext.10f6d9b8.webp";